import { AxiosRequestConfig } from 'axios';

import { get } from 'api/requests';

type DownloadFileParams = {
  url: string;
  params?: AxiosRequestConfig['params'];
  config?: AxiosRequestConfig;
};

const getFilename = (contentDisposition?: string) => {
  if (!contentDisposition) {
    return 'download';
  }

  const decoded = decodeURI(contentDisposition);

  if (decoded.includes('filename*=utf-8')) {
    const [, filename] = decoded.split('filename*=utf-8');
    return filename.slice(2);
  }

  const [, filename] = decoded.split('filename=');
  return filename?.slice(1, -1) || 'download';
};

export const downloadFileByGet = async ({ url, params, config }: DownloadFileParams) => {
  const result = await get<ArrayBuffer>(url, params, {
    ...config,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'blob',
      ...config?.headers,
    },
  });

  const filename = getFilename(result.headers['content-disposition']);
  const urlObject = window.URL.createObjectURL(new Blob([result.data]));
  const link = document.createElement('a');

  link.href = urlObject;
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();
  link.remove();
};
